import React, { useEffect, useState } from "react";
import { InputLabel, makeStyles, Select } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
// import MDBox from "./MDBox";
// import MDInput from "./MDInput";
// import MDButton from "./MDButton";
import { AddEditQuizTranslationCall } from "../../redux/api/quizTitle.api";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { FormControl, MenuItem } from "@mui/material";

const CustomTranslationDrawer = ({
  open,
  toggleDrawer,
  lang,
  quiz_id,
  data,
  refreshQuizzes,
  fetchQuestions,
}) => {
  const classes = useStyles();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [language, setLanguage] = useState(lang);
  const [answerA, setAnswerA] = useState("");
  const [answerB, setAnswerB] = useState("");
  const [answerC, setAnswerC] = useState("");
  const [answerD, setAnswerD] = useState("");

  useEffect(() => {
    if (data) {
      setTitle(data?.title || "");
      setDescription(data?.content || "");
      setImage(data?.image || "");
      setAnswerA(data?.answer_a || "");
      setAnswerB(data?.answer_b || "");
      setAnswerC(data?.answer_c || "");
      setAnswerD(data?.answer_d || "");
    } else {
      setTitle("");
      setDescription("");
      setImage("");
      setAnswerA("");
      setAnswerB("");
      setAnswerC("");
      setAnswerD("");
    }
  }, [data]);

  const save = async () => {
    const body = {
      quiz_id,
      language,
      title,
      content: description,
      image,
      answer_a: answerA,
      answer_b: answerB,
      answer_c: answerC,
      answer_d: answerD,
    };

    if (data?.id) {
      await AddEditQuizTranslationCall({ ...body, id: data.id });
    } else {
      await AddEditQuizTranslationCall(body);
    }

    await refreshQuizzes();
    fetchQuestions();
    toggleDrawer(false);
  };

  const remove = async () => {
    if (!data?.id) return;
    const confirmed = window.confirm("Delete this translation?");
    if (!confirmed) return;

    await refreshQuizzes();
    toggleDrawer(false);
    fetchQuestions();
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
    // setLanguage(event.target.value);
    // dispatch(setLang(event.target.value));
  };

  return (
    <Drawer
      className={classes.drawer}
      variant="temporary"
      anchor="right"
      open={open}
      onClose={() => toggleDrawer(false)}
      classes={{ paper: classes.drawerPaper }}
    >
      <div className={classes.list}>
        <MDBox component="form" role="form">
          {/* Language Dropdown */}
          <MDBox mt={5} mb={2}>
            <FormControl sx={{ minWidth: "100%", "& .MuiInputBase-root": { minHeight: 48 } }}>
              <InputLabel>Language</InputLabel>
              <Select
                value={language}
                disabled={language !== "en"}
                onChange={handleLanguageChange}
                sx={{ minHeight: 48 }}
              >
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="pt">Portugal</MenuItem>
                <MenuItem value="es">Spanish</MenuItem>
                <MenuItem value="it">Italian</MenuItem>
                <MenuItem value="ge">Germany</MenuItem>
                <MenuItem value="nl">Dutch</MenuItem>
                <MenuItem value="cn">Chinese</MenuItem>
                <MenuItem value="ja">Japanese</MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </MDBox>
          <MDBox mt={5} mb={2}>
            <MDInput
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              type="text"
              label="Title"
              fullWidth
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              multiline
              rows={6}
              type="text"
              label="Description"
              fullWidth
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              value={answerA}
              onChange={(e) => setAnswerA(e.target.value)}
              type="text"
              label="Answer A"
              fullWidth
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              value={answerB}
              onChange={(e) => setAnswerB(e.target.value)}
              type="text"
              label="Answer B"
              fullWidth
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              value={answerC}
              onChange={(e) => setAnswerC(e.target.value)}
              type="text"
              label="Answer C"
              fullWidth
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              value={answerD}
              onChange={(e) => setAnswerD(e.target.value)}
              type="text"
              label="Answer D"
              fullWidth
            />
          </MDBox>
        </MDBox>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 20,
          }}
        >
          <MDButton
            disabled={!description && !title}
            color="info"
            variant="contained"
            onClick={save}
          >
            Save
          </MDButton>
          <MDButton
            disabled={!data?.id}
            color="error"
            variant="contained"
            onClick={remove}
          >
            Delete
          </MDButton>
        </div>
      </div>
    </Drawer>
  );
};

export default CustomTranslationDrawer;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 320,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 320,
    backgroundColor: "#f5f5f5",
  },
  list: {
    margin: "0 20px",
  },
}));
